import { render, staticRenderFns } from "./instagram_prize_dialog.vue?vue&type=template&id=3155ac60&scoped=true"
import script from "./instagram_prize_dialog.vue?vue&type=script&lang=ts"
export * from "./instagram_prize_dialog.vue?vue&type=script&lang=ts"
import style0 from "./instagram_prize_dialog.vue?vue&type=style&index=0&id=3155ac60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155ac60",
  null
  
)

export default component.exports